import { Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutWirecodeLookup } from "./autogen/AutogenLayoutWirecodeLookup";

export class WirecodeLookup extends AutogenLayoutWirecodeLookup {

    tableWireCodeLookupOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const labelRequireOrder = tableRow.findComponentById("labelRequireOrder") as Label;
        const labeldeduction = tableRow.findComponentById("labeldeduction") as Label;
        const labelOtherCharge = tableRow.findComponentById("labelOtherCharge") as Label;
        labelRequireOrder.text = labelRequireOrder.text === "Y" ? "Yes" : "No";
        labelOtherCharge.text = labelOtherCharge.text === "Y" ? "Yes" : "No";
        labeldeduction.text = labeldeduction.text === "Y" ? "Yes" : "No";
        if (tableRow.index > 0) {
            tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
        }
    }

}
